import { forwardRef, type HTMLAttributes, type ReactNode } from 'react'
import { cn } from '@/lib/utils'

/**
 * ListItem — строка списка (`.li` макета): имя, мета и необязательное действие в одну строку,
 * центральная область растягивается. Разделитель снизу (последняя строка без него).
 */
export interface ListItemProps extends HTMLAttributes<HTMLDivElement> {
  name: ReactNode
  meta?: ReactNode
  leading?: ReactNode
  action?: ReactNode
}

export const ListItem = forwardRef<HTMLDivElement, ListItemProps>(
  ({ className, name, meta, leading, action, ...props }, ref) => (
    <div
      ref={ref}
      className={cn('flex items-center gap-3 border-b border-line py-2.5 last:border-b-0', className)}
      {...props}
    >
      {leading}
      <div className="min-w-0 flex-1">
        <div className="truncate font-medium text-txt">{name}</div>
        {meta ? <div className="text-12 text-txt-secondary">{meta}</div> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  ),
)
ListItem.displayName = 'ListItem'
